import { useCallback, useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { completePlaidInvestmentUpgrade, createPlaidInvestmentUpgradeLinkToken } from "../lib/financeConnections";

const TOKEN_KEY="famdashfun_plaid_investment_upgrade_token";
const CONNECTION_KEY="famdashfun_plaid_investment_upgrade_connection";
const isOAuthReturn=()=>new URLSearchParams(window.location.search).has("oauth_state_id");

export function PlaidInvestmentUpgradeButton({householdId,connectionId,onUpgraded}:{householdId:string;connectionId:string;onUpgraded?:()=>void}){
  const returning=isOAuthReturn()&&sessionStorage.getItem(CONNECTION_KEY)===connectionId;
  const [token,setToken]=useState<string|null>(()=>returning?sessionStorage.getItem(TOKEN_KEY):null);
  const [status,setStatus]=useState<"idle"|"preparing"|"linking"|"syncing"|"success"|"error">("idle");
  const [message,setMessage]=useState("");

  const clearReturn=()=>{
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(CONNECTION_KEY);
    if(isOAuthReturn())window.history.replaceState({},document.title,window.location.pathname);
  };

  const onSuccess=useCallback(async()=>{
    setStatus("syncing");setMessage("Importing holdings…");
    try{
      const result=await completePlaidInvestmentUpgrade(householdId,connectionId);
      const holdings=Number(result.syncResult?.investments?.holdings||0);
      clearReturn();setToken(null);setStatus("success");
      setMessage(holdings?holdings+" holding"+(holdings===1?"":"s")+" imported.":"Investments enabled. Plaid is still preparing holdings; refresh again shortly.");
      onUpgraded?.();
    }catch(error){
      setStatus("error");setMessage(error instanceof Error?error.message:"Holdings could not be enabled.");
    }
  },[householdId,connectionId,onUpgraded]);

  const {open,ready,error}=usePlaidLink({
    token,
    onSuccess,
    receivedRedirectUri:returning?window.location.href:undefined,
    onExit:exit=>{if(exit){setStatus("error");setMessage(exit.display_message||"Schwab authorization was not completed.");}else if(status==="linking"){setStatus("idle");}}
  });

  useEffect(()=>{if(token&&ready){setStatus("linking");open();}},[token,ready,open]);
  useEffect(()=>{if(error){setStatus("error");setMessage("Plaid Link could not load. Try again.");}},[error]);

  async function begin(){
    setStatus("preparing");setMessage("Opening Schwab securely…");
    try{
      const result=await createPlaidInvestmentUpgradeLinkToken(householdId,connectionId);
      sessionStorage.setItem(TOKEN_KEY,result.linkToken);
      sessionStorage.setItem(CONNECTION_KEY,connectionId);
      setToken(result.linkToken);
    }catch(error){
      setStatus("error");setMessage(error instanceof Error?error.message:"Could not start the holdings repair.");
    }
  }

  const busy=["preparing","linking","syncing"].includes(status);
  return <span className="finance-investment-upgrade">
    <button type="button" onClick={()=>void begin()} disabled={busy}>{busy?(status==="syncing"?"Syncing holdings…":"Opening Plaid…"):"Enable holdings"}</button>
    {message&&<small role="status" aria-live="polite">{message}</small>}
  </span>;
}
